import React from 'react';
import {t} from 'i18next';
import {emedikusService} from '../../../service/emedikus.service';
import Button from '../../../incase-domain/components/button/Button';

function EmedikusLoginButton(): JSX.Element {
    const handleLogin = (): void => {
        emedikusService.login();
    };

    return (
        <Button variant="soft" color="primary" size="md" onClick={handleLogin} dataCy="emedikus_login_button">
            {t('form.emedikus')}
        </Button>
    );
}

export default EmedikusLoginButton;
